<template>
    <div id="home">
        <div class="homeWrap" v-show="showList">
            <!--<div class="logoTitle">-->
                <!--&lt;!&ndash;<p>教学系统管理</p>-->
                <!--<p>Teaching System Management</p>&ndash;&gt;-->
                <!--<p><strong>中国足球协会信息化平台教练员培训管理系统</strong></p>-->
            <!--</div>-->
<!--            <div class="HTM_PRO" v-if="showEnrollQingxun  && !isFive">-->
<!--                <el-button type="primary" class="HTM_PRO_BUTTON" @click="isShowActionInfo=true" style="background-color: #3a8ee6;border-color: #3a8ee6;">精英青训B/A级和青训总监培训报名<span style="margin-left: 5px">>></span>-->
<!--                </el-button>-->
<!--            </div>-->
            <div class="moduleWrap">
                <div class="moduleUp">
                    <router-link class="linkA linkA_samll" to="/expireStudent/tran_his">
                        <div class="moduleItem classItem">
                            <div class="icon">
                                <v-icon name="business-time" scale="4.5"></v-icon>
                            </div>
                            <p>培训经历和证书</p>
                        </div>
                    </router-link>
                    <router-link v-if="!isFive" class="linkA linkA_samll" to="/expireStudent/getLicenseList">
                        <div class="moduleItem">
                            <div class="icon">
                                <v-icon name="regular/file-alt" scale="3.5"></v-icon>
                            </div>
                            <p>教练员执照</p>
                        </div>
                    </router-link>
                    <div class="linkA linkA_big" >
                        <div class="moduleItem-big">
                            <div class="item-wrapper-normal">
                                <div class="icon" style="margin:5px 5px 0 5px">
                                    <v-icon name="chalkboard-teacher" scale="4"></v-icon>
                                </div>
                                <p>我的简历</p>
                                <div class="tips"
                                  v-if="info_status">
                                    <div class="icon">
                                        <v-icon name="comment-alt" scale="3"></v-icon>
                                    </div>
                                    <div class="num">
                                        <span>信息审核拒绝</span>
                                    </div>
                                </div>
                            </div>
                            <div class="item-wrapper-hover">
                                <div @click="navigateToUrl('/expireStudent/basicSetting')" class="item-wrapper-hover-content item-wrapper-hover-left">
                                    <el-badge :is-dot="info_status">
                                    <div class="icon">
                                        <v-icon name="user-edit" scale="4"></v-icon>
                                    </div>
                                    </el-badge>
                                    <p>基本信息</p>
                                </div>
                                <div @click="navigateToUrl('/expireStudent/qualificationSetting')" class="item-wrapper-hover-content item-wrapper-hover-right">
                                    <div class="icon">
                                        <v-icon name="user-shield" scale="4"></v-icon>
                                    </div>
                                    <p>简历内容</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="moduleDown" v-if="(showEnroll || achievement_verify==='N') && !isFive">
                <!-- <router-link class="linkA linkA_samll" to="/expireStudent/record_qualification"  v-if="achievement_verify!=='N' && showUploadQua">
                    <div class="moduleItem">
                        <div class="icon">
                            <v-icon name="file-invoice" scale="4"></v-icon>
                        </div>
                        <p>缺失资质</p>
                    </div>
                </router-link> -->

                <router-link class="linkA linkA_190" to="/expireStudent/registrationList">
                  <div class="moduleItem">
                    <div class="icon">
                      <v-icon name="chalkboard-teacher" scale="4"></v-icon>
                    </div>
                    <p>等级培训和补考报名</P><P style="margin-top: 0;font-size: 20px;">（B级及以上级别）</p>
                  </div>
                </router-link>
                <router-link class="linkA linkA_190" to="/expireStudent/continueList">
                  <div class="moduleItem">
                    <div class="icon">
                      <v-icon name="chalkboard-teacher" scale="4"></v-icon>
                    </div>
                    <p>继续教育培训报名</P><P style="margin-top: 0;font-size: 20px;">（C级及以上级别）</p>
                  </div>
                </router-link>
                <router-link class="linkA linkA_190" :to="{path: 'registrationList', query: {enroll_list_type: 'zhuanxiang'}}">
                  <div class="moduleItem">
                    <div class="icon">
                      <v-icon name="chalkboard-teacher" scale="4"></v-icon>
                    </div>
                    <p>专项培训和补考报名 </P><P style="margin-top: 0;font-size: 20px;">（守门员/体能等）</p>
                  </div>
                </router-link>
              </div>
                <div class="moduleDown">
                    <router-link  v-if="advance_admission_show" class="linkA linkA_190" :to="{path: 'confirmPreAdmission', query: {advance_uuid: advance_admission}}">
                        <div class="moduleItem">
                            <div class="icon">
                                <v-icon name="file-invoice" scale="4"></v-icon>
                            </div>
                            <p>预录取培训班</p>
                        </div>
                    </router-link>
                    <router-link  v-if="!isFive" class="linkA linkA_190" to="/expireStudent/education_list">
                        <div class="moduleItem">
                            <div class="icon">
                                <v-icon name="file-invoice" scale="4"></v-icon>
                            </div>
                            <p>线上继续教育</p>
                        </div>
                    </router-link>
                    
                    <router-link class="linkA linkA_190" to="/expireStudent/materials">
                        <div class="moduleItem">
                            <div class="icon">
                                <v-icon name="user-cog" scale="4"></v-icon>
                            </div>
                            <p>学习资料和下载</p>
                        </div>
                    </router-link>
                    <router-link v-if="!isFive" class="linkA linkA_190" to="/expireStudent/alter_avi_list">
                        <div class="moduleItem">
                            <div class="icon">
                                <v-icon name="user-plus" scale="4"></v-icon>
                            </div>
                            <p>教练员注册</p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <el-dialog class="eval-dialog"
          :visible.sync="allDisabled"
          title
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          width="460px"
          center>
            <div class="to-eval">
                <div class="img">
                    <img src="@/assets/images/evaluation_tips.png" alt>
                </div>
                <div class="tips">
                    <p v-html="tips.title"></p>
                </div>
                <el-button type="primary" @click="gotoSetting">{{tips.button_text}}</el-button>
            </div>
        </el-dialog>
        <select-organ :organList="organList" @hideTips="hideTips" :showdialog="showSelectOrganDialog"></select-organ>
        <enroll-dialog :isOpen.sync="isShowActionInfo"></enroll-dialog>
    </div>
</template>

<script>
    import {isEvaluated} from "@/api/training_student/api";
    import "vue-awesome/icons/user-plus";
    import {info_view,organList} from "@/api/ab_signup/api";
    import { getStuHistoryTrian } from "@/api/system_manager/api";
    import {questionCheck} from "@/api/survey/index";
    import "vue-awesome/icons/sitemap";
    import "vue-awesome/icons/clipboard-list";
    import "vue-awesome/icons/users-cog";
    import "vue-awesome/icons/chalkboard-teacher";
    import "vue-awesome/icons/user-cog";
    import "vue-awesome/icons/user-friends";
    import "vue-awesome/icons/user-ninja";
    import "vue-awesome/icons/user-alt";
    import "vue-awesome/icons/regular/file-alt";
    import "vue-awesome/icons/check";
    import "vue-awesome/icons/file-signature";
    import "vue-awesome/icons/comment-alt"; // 提示气泡
    import "vue-awesome/icons"
    import fiveMixins from '@/minix/fiveMixins';

    export default {
        name: "expireIndex",
        mixins: [fiveMixins],
      data() {
        return {
          user_id: this.$route.query.u_id,
          info_status:false,
          organList:[],
          showSelectOrganDialog:false,
          ifDiaShow: false,
          allDisabled:false,
          showDialog: false,
          showInfo: true,
          showList: false,
          showEnroll: false,
          showEnrollQingxun: false,
          isShowActionInfo: false,
          showUploadQua:true,
          showEmpty: false,
          achievement_verify:'',
          levelList:[],
          info: {},
          list: [],
          loading:true,
          survey_id:'',
          isSurvey:0,
          tips:{
            title:"",
            button_text:"",
            show_type:"",
          },
          eva_c_id:0,
          advance_admission:"",
          advance_admission_name:"",
          advance_admission_show:false,
          enroll_choose_again_uuid:"",
          url:'',
          license:{},
          coachHistoryInfo: {
            coachUser: {},
            ranks: [],
            certificates: [],
            achievemens: [],
            rankList: []
          },
          curStuInfo: {
            studentSingnInfo: {},
            language_list: [],
            academic_data: [],
            coach_data: [],
            experience_data: [],
            playing_data: []
          },
        };
      },
        components: {
            "v-icon": () => import("vue-awesome/components/Icon"),
          "select-organ" :() => import('@/components/Tips/select-organ'),
          "enroll-dialog": () => import("@/views/Login/qingxunEnrollInfo"),
        },
      created() {
        this.getStuList();
        this.isEvaled();
        this.infoRefused();
      },
        methods:{
            navigateToUrl(url) {
                this.$router.push({
                    path: url
                })
            },
          infoRefused(){
            return this.$store.state.infoRefused
          },
          isEvaled() {
            isEvaluated().then( async ({data}) => {
              if (data.status === 0) {
  
                // 判断是否有调查要填写
                try{
                  const res = await questionCheck();
                  const { isSurvey, question } = res.data.result;
                  // console.log('question', question)
                  this.isSurvey = isSurvey;
                  if(question) this.survey_id = question.survey_id;
                } catch(e){
                  console.log(e)
                }
                
                this.achievement_verify=data.result.achievement_verify;
                if (Number(data.result.binding_org)===1){
                  this.getOrganList();
                  return
                }
                this.info_status = data.result.info_status==='refused' ? true : false;
                if(data.result.advance_admission_uuid){
                  this.advance_admission_show = data.result.advance_admission_uuid!=='' ? true : false;
                }
                this.advance_admission = data.result.advance_admission_uuid;
                this.enroll_choose_again_uuid = data.result.enroll_choose_again_uuid;
                this.allDisabled = data.result.perfect_info === 1 || data.result.eva_show > 0 || Boolean(data.result.has_license) || data.result.perfect_info_again === 1  || this.isSurvey === 1 || data.result.has_advance_admission === 1 || data.result.enroll_choose_again === 1;
                if(data.result.perfect_info === 1){
                  this.tips.title="首次登录需要完善个人资料<br/>资料内容可在“我的简历-->基本信息”中修改。";
                  this.tips.button_text="前往完善资料";
                  this.tips.show_type="perfect_info";
                }
                else if(data.result.perfect_info_again === 1){
                  if(this.isFive) {
                    this.tips.title="根据中国足协社会足球部要求，需要您在简历中进一步详细完善运动经历、执教经历等信息。";
                  } else {
                    this.tips.title="根据中国足协技术部要求，需要您在简历中进一步详细完善运动经历、执教经历等信息。";
                  }
                  this.tips.button_text="前往完善资料";
                  this.tips.show_type="perfect_info_again";
                }
                else if(data.result.has_license){
                  this.tips.title="您有新的教练员执照待领取，<br/>请填写领取信息";
                  this.tips.button_text="前往填写";
                  this.tips.show_type="licenseInfo";
                }
                else if (data.result.eva_show) {
                  this.tips.title = "培训班已经结束，请您填写问卷调查。";
                  this.tips.button_text = "前往问卷调查";
                  this.tips.show_type = "eva_show";
                  this.eva_c_id = data.result.eva_show;
                }
                else if (this.isSurvey===1){
                  this.tips.title="有一份问卷调查需要您完成填写。";
                  this.tips.button_text="前往问卷调查";
                  this.tips.show_type="survey";
                }
                else if (data.result.has_advance_admission){
                  this.tips.title="您已被预录取参加“"+data.result.advance_admission_name+"”，确认是否可以参加本期培训班？";
                  this.tips.button_text="前往确定";
                  this.tips.show_type="advance_admission";
                }
                else if (data.result.enroll_choose_again){
                  this.tips.title="您需要根据“"+data.result.enroll_choose_again_name+"”内容，选择意向参加的培训班，感谢您的配合。";
                  this.tips.button_text="前往选择";
                  this.tips.show_type="enroll_choose_again";
                }
              }
            });
          },
          getStuList() {
            this.showList = false;
            getStuHistoryTrian({})
            .then(res => {
              this.loading=false;
              const { result } = res.data;
              /*this.$set(this.paging, "prePage", result.page.page_size);
              this.$set(this.paging, "total", result.page.total_row);
              this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);*/
              this.list = result.list;
              // 处理历史培训数据
              if (this.list.length>0){
                this.list.forEach((item,index)=>{
                  if (item.class_level==='C'||item.class_level==='D') this.showUploadQua=false;
                })
              }
              if (result.coachHistoryInfo) {
                const { list } = result;
                const {coachUser, ranks, certificates, achievemens} = result.coachHistoryInfo;
                if (coachUser) this.coachHistoryInfo.coachUser = coachUser; // 获取用户信息
                if (ranks) this.coachHistoryInfo.ranks = ranks; // 获取等级
                if (certificates) this.coachHistoryInfo.certificates = certificates; //获取证书
                if (achievemens) this.coachHistoryInfo.achievemens = achievemens; //获取成绩信息
                // 处理证书
                let certificateInfo = {};
                if (certificates && certificates.length > 0) {
                  for (let i = 0; i < certificates.length; i++) {
                    const {rankId} = certificates[i];
                    certificateInfo[rankId] = certificates[i];
                  }
                }
                // 处理成绩
                let achievemensInfo = {};
                if (achievemens && achievemens.length > 0) {
                  for (let i = 0; i < achievemens.length; i++) {
                    const {rankId} = achievemens[i];
            
                    achievemensInfo[rankId] = achievemens[i];
                  }
                }
                // 获取平台培训数据
                let coachTrainInfo = {};
                if (this.list.length > 0) {
                  for (let i = 0; i < this.list.length; i++) {
                    const {unique_code} = this.list[i];
                    coachTrainInfo[unique_code] = this.list[i];
                  }
                }
        
                // 合并成绩
                if (ranks && ranks.length > 0) {
                  for (let j = 0; j < ranks.length; j++) {
                    const {id} = ranks[j];
                    ranks[j].is_old = 1;
                    //成绩的级别放入levelList
                    if (ranks[j].coachRankStatus!=='未通过'){
                      this.levelList.push(ranks[j].coachRankType)
                    }
                    if (certificateInfo[id]) {
                      const {certificateNum, certificateDate, validityStart,certificateUrl} = certificateInfo[id];
                      ranks[j].certificateNum = certificateNum;
                      ranks[j].certificateDate = certificateDate;
                      ranks[j].validityStart = validityStart;
                      if (certificateUrl) ranks[j].certificateUrl = certificateUrl;
                    }
                    if (achievemensInfo[id]) {
                      const {classAddress, classEnd, classStart, lecturerName, classUid} = achievemensInfo[id];
                      ranks[j].classAddress = classAddress;
                      ranks[j].classEnd = classEnd;
                      ranks[j].classStart = classStart;
                      ranks[j].lecturerName = lecturerName;
                      ranks[j].classUid = classUid;
                      ranks[j].end_date = new Date(classEnd).getTime();
                      if (!coachTrainInfo[classUid]) {
                        this.list.push(ranks[j]);
                      }
                    }
                  }
                }
                // 按照培训结束日期进行排序
                if (list && list.length) this.list = list.sort((pre, next) => {
                  return next.end_date - pre.end_date;
                });
              }
              if (this.list.length > 0) {
                // for (let res of this.list){
                //    // list中的成绩级别放入 levelList
                //    this.levelList.push( res.class_level);
                // };
                if (this.levelList.includes('B')||this.levelList.includes('A')||this.levelList.includes('P')||this.levelList.includes('PRO')||this.levelList.includes('0')||this.levelList.includes('C')){
                  this.showEnroll=true;
                }
  
                if (this.levelList.includes('B')||this.levelList.includes('A')||this.levelList.includes('P')||this.levelList.includes('PRO')||this.levelList.includes('0')){
                  this.showEnrollQingxun=true;
                }
                
                this.showList = true;
                this.showEmpty = false;
              } else {
                this.showList = false;
                this.showEmpty = true;
              }
            })
            .catch(err => {
              console.error(err);
            });
          },
          getOrganList(){
            organList({}).then(
              ({ data: { result, status } }) => {
                if (status === 0) {
                  this.organList = result.list;
                  this.showSelectOrganDialog=true;
                }
              }
            );
          },
          gotoSetting(){
            if(this.tips.show_type === 'perfect_info'){
              this.$router.push({
                path: "vita",
                query: {}
              });
            }else if(this.tips.show_type === 'perfect_info_again'){
              this.$router.push({
                path: "qualificationSetting",
                query: {}
              });
            }else if(this.tips.show_type === 'eva_show'){
              this.$router.push({
                path: "create_evaluation",
                query: {c_id:this.eva_c_id}
              });
            }else if(this.tips.show_type==='licenseInfo'){
              this.$router.push({
                path: "getLicenseList",
                query: {}
              });
            }else if(this.tips.show_type === 'survey'){
              this.$router.push({
                path: "/survey/survey_index",
                query: {survey_id:this.survey_id}
              });
            }else if(this.tips.show_type === 'advance_admission'){
              this.$router.push({
                path: "confirmPreAdmission",
                query: {advance_uuid:this.advance_admission}
              });
            }else if(this.tips.show_type === 'enroll_choose_again'){
              this.$router.push({
                path: "enroll_choose_again",
                query: {signId:this.enroll_choose_again_uuid}
              });
            }
          },
          hideTips(bool){
            if (bool){
              this.showSelectOrganDialog=false;
              this.isEvaled()
            }
          },
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~@/assets/css/variable';
    #home {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
        .homeWrap {
            width: 930px;
            position: relative;
            .HTM_PRO{
                position: absolute;
                top: -1px;  /* 距离父元素顶部50像素 */
                right: 20px; /* 距离父元素左侧20像素 */
            }
            .logoTitle {
                height: 85px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 0 0 40px 0;
                color: $color_title;
                font-size: 40px;
                font-weight: bolder;
                text-shadow : 2px 1px 3px #231815;
            }
            .moduleWrap {
                .moduleUp {
                    margin: 40px 0;
                    display: flex;
                    .linkA {
                        flex: 1 1 auto;
                        margin: 0 20px;
                    }
                    .linkA_samll {
                        width: 195px;
                    }
                    .linkA_big {
                        width: 420px;
                    }
                }
                .moduleDown {
                    margin: 40px 0;
                    display: flex;
                    .linkA {
                        flex: 1 1 auto;
                        margin: 0 20px;
                    }
                    .linkA_samll {
                        width: 420px;
                    }
                    .linkA_190 {
                      width 190px
                    }
                    .linkA_big {
                        width: 430px;
                    }
                }
                .moduleItem {
                    position: relative;
                    width: 100%;
                    height: 200px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color: $color_white;
                    font-size: 23px;
                    background-color: $block_bg_color_base;
                    cursor: pointer;
                    .icon {
                        display: flex;
                        align-items: center;
                    }
                    p {
                        margin: 20px 0 0;
                    }

                }
                .moduleItem-big {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    cursor default
                    .item-wrapper-normal {
                        width: 100%;
                        height: 200px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        color: $color_white;
                        font-size: 23px;
                        background-color: $block_bg_color_base;
                        cursor: pointer;
                        .icon {
                            display: flex;
                            align-items: center;
                        }
                        p {
                            margin: 20px 0 0;
                        }
                        .tips {
                            position: absolute;
                            top: calc(20% - 20px);
                            right: calc(35% - 10px);
                            .icon {
                                color: $color_err;
                            }
                            .num {
                                width: 100%;
                                height: 100%;
                                padding: 2px;
                                position: absolute;
                                top: 0;
                                left: 0;
                                text-align: center;
                                font-size: 13px;
                            }
                        }
                    }
                    .item-wrapper-hover {
                        width 100%
                        height 100%
                        display none
                        .item-wrapper-hover-content {
                            height: 100%;
                            width: calc(50% - 15px);
                            background-color: $block_bg_color_base;
                            color: $color_white;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            color: $color_white;
                            font-size: 23px;
                            cursor: pointer;
                            .icon {
                                display: flex;
                                align-items: center;
                            }
                            p {
                                margin: 20px 0 0;
                            }
                        }
                    }
                }

                .moduleItem-big:hover .item-wrapper-normal {
                    display none
                }
                .moduleItem-big:hover .item-wrapper-hover {
                    display flex
                    justify-content space-between
                    width 100%
                    height 100%
                }
                .classItem {
                    .tips {
                        position: absolute;
                        top: calc(20% - 15px);
                        right: calc(35% - 15px);
                        .icon {
                            color: $color_suc;
                        }
                        .num {
                            width: 100%;
                            height: 100%;
                            padding: 2px 0 0;
                            position: absolute;
                            top: 0;
                            left: 0;
                            text-align: center;
                            font-size: $font_size_big;
                        }
                    }
                }
            }
        }
        .to-eval{
            font-size:16px;
            text-align:center;
            img{
                width:100px
            }
            .tips{
                margin-bottom:15px
            }
        }
    }
</style>
<style lang="stylus" >
    .el-badge__content.is-dot {
        height: 12px;
        width: 12px;
        padding: 0;
        right: 0;
        border-radius: 50%;
    }
</style>

